import { ExtendableError } from '@tunein/web-utils';
export class OpmlError extends ExtendableError {
    status;
    faultCode;
    constructor(response) {
        const { fault, faultCode, status } = response?.head || {};
        const message = fault || 'Unknown OPML error';
        super(message);
        this.name = 'OpmlError';
        this.message = message;
        this.status = Number.parseInt(status);
        this.faultCode = faultCode;
    }
}
